import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation, Trans } from "react-i18next";
import Orb from "./Orb";
import Collab from "../assets/images/collab.png";

const ContactIntro = () => {
  const { t } = useTranslation();
  return (
    <section className="contact-intro">
      <Container>
        <Orb color="rgb(139, 210, 211)" top="-20vh" right="-20vh" />
        <div className="banner">
          <Row className="justify-content-center">
            <Col md={8} className="d-flex justify-content-center flex-column">
              <h1 className="display-5 mb-4 section-title">
                <Trans
                  i18nKey="contact-intro-title"
                  components={{
                    blue: <span className="color-blue" />,
                    br: <br />,
                  }}
                />
              </h1>
              <p className="lead">{t("contact-intro-desc")}</p>
            </Col>
            <Col md={4} className="d-flex justify-content-center align-items-center text-center">
              <img src={Collab} alt="Collab" className="img-fluid" />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default ContactIntro;
